module.exports = __webpack_public_path__ + "static/media/inProgress.8b41f3c1.svg";